import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Input, Modal, Switch, Tooltip } from "antd";
import { toast } from 'react-toastify';
import { putRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import editIcon from "../../assets/images/edit-icon.svg";
import './proSettings.scss';
import { truncate } from '../../utils/helper';

const ProSettings = ({ isModalOpen, setIsModalOpen, proSettingsModalData, setProSettingsModalData, fetchData, allProSettingsData, setAllProSettingsData }) => {

    const [proSettingsNameMapping, setProSettingsNameMapping] = useState([])

    const [proSettings, setProSettings] = useState({})
    const [initialProSettings, setInitialProSettings] = useState({})

    const [allActive, setAllActive] = useState(false)
    const [loading, setLoading] = useState(false)
    const [editProSettingName, setEditingProSettingName] = useState(null)
    const [editProSettingNameLoading, setEditProSettingNameLoading] = useState(false)

    const allChecker = () => {
        let allTrue = true
        for (const key in proSettings) {
            if (!proSettings[key]) {
                allTrue = false
                break
            }
        }
        return allTrue
    }

    const handleChecker = useCallback((passedKey) => {
        setProSettings(prevSettings => ({
            ...prevSettings,
            [passedKey]: !prevSettings[passedKey]
        }));
    }, [])

    const handleAllToggle = useCallback(() => {
        let allTrueSettings = {}
        for (const key in proSettings) {
            allTrueSettings[key] = !allActive
        }
        setProSettings(allTrueSettings)
    }, [proSettings, allActive])

    const closeSettings = () => {
        setProSettingsModalData({})
        setEditingProSettingName(null)
        setIsModalOpen(false)
    }

    const submit = async () => {
        console.log('Submit clicked',)
        setLoading(true);
        try {
            var formData = Object.keys(proSettings).map((masterDataId) => {
                return { ...proSettingsNameMapping[masterDataId], primaryToggle: proSettings[masterDataId] }
            })

            // Send the PUT request
            const response = await putRequest(userServiceApi.updateProSetting(), formData);

            if (response) {
                toast.success("Partner Details Updated Successfully");
                fetchData(); // Fetch the updated data
                closeSettings(); // Close settings modal
            } else {
                toast.error('Failed to update pro settings');
            }
        } catch (error) {
            toast.error('Failed to update pro settings');
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditClick = (key) => {
        setEditingProSettingName(key)
    }

    const handleProSettingEditCancel = () => {
        setEditingProSettingName(null)
    }

    const handleProSettingsEdit = (e) => {
        console.log('e', e.target.value)
        setEditingProSettingName((setting) => {
            return {
                ...setting,
                displayName: e.target.value
            }
        })
    }

    const handleProSettingEditSave = async () => {
        const formData = [editProSettingName]
        try {
            setEditProSettingNameLoading(true)
            const res = await putRequest(userServiceApi.updateProSetting(), formData)
            if (res) {
                console.log('res', res)
                toast.success("Successfully updated pro-setting");
                setEditingProSettingName(null)

                // we need to update setAllProSettingsData to latest changes
                setAllProSettingsData((staleProSetting) => {
                    let updatedProSetting = staleProSetting.map((setting) => {
                        if (setting.masterDataId === res[0].masterDataId) {
                            return res[0]
                        }
                        return setting
                    })
                    return updatedProSetting
                })

            }
        } catch (error) {
            toast.error("Failed to update pro-setting");
        }
        finally {
            setEditProSettingNameLoading(false)
        }
    }

    const ProSettingsHasChanges = useMemo(() =>
        JSON.stringify(initialProSettings) !== JSON.stringify(proSettings),
        [initialProSettings, proSettings]
    );

    useEffect(() => {

        let tempAllProSettingsData = {}
        allProSettingsData.forEach((setting) => {
            tempAllProSettingsData[setting.masterDataId] = setting
        })
        setProSettingsNameMapping(tempAllProSettingsData)

    }, [allProSettingsData])

    useEffect(() => {
        setAllActive(allChecker())
    }, [proSettings])

    useEffect(() => {

        let tempProSettingsPrimaryToggle = {}
        allProSettingsData.forEach((setting) => {
            tempProSettingsPrimaryToggle[setting.masterDataId] = setting.primaryToggle
        })

        setProSettings(tempProSettingsPrimaryToggle)
        setInitialProSettings(tempProSettingsPrimaryToggle)
    }, [allProSettingsData])

    return (
        <Modal
            closable={false}
            footer={null}
            open={isModalOpen}
            centered
            onCancel={closeSettings}
        >
            <>
                <div className="header">
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        {proSettingsModalData?.mediaLink ? <div style={{ backgroundColor: '#e7e3e3', borderRadius: '50%', width: '50px', height: '50px', backgroundImage: `URL(${proSettingsModalData?.mediaLink})`, backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }} alt="" /> : ''}
                        <h3 className="ms-settings-header settings-header"> {truncate(proSettingsModalData?.name || 'Partner', 20)} Pro Settings</h3>
                    </div>

                    <div className="all-switch ms-settings" style={{ border: 'none', boxShadow: 'none' }} >
                        <div className='ms-settings-switch'>
                            <Switch
                                className=" siteSetting-switch"
                                checked={allActive}
                                onChange={(e) => handleAllToggle(e)}
                                disabled={editProSettingName}

                            />
                        </div>
                    </div>
                </div>


                <div className="ms-settings">
                    {proSettings && Object.keys(proSettings).length > 0 ? (
                        <React.Fragment>
                            {proSettings && Object.keys(proSettings).map((key) => {
                                return (
                                    editProSettingName?.masterDataId === key
                                        ? <div className='edit-pro-settings' >
                                            <Input value={editProSettingName?.displayName} onChange={(e) => { handleProSettingsEdit(e) }} />
                                            <Button onClick={handleProSettingEditCancel} >
                                                Cancel
                                            </Button>
                                            <Button className='redBtn' onClick={handleProSettingEditSave} loading={editProSettingNameLoading} >
                                                Save
                                            </Button>
                                        </div> : <div className="ms-settings-row" key={key}>
                                            <div className="ms-settings-label">
                                                {truncate(proSettingsNameMapping[key].displayName, 34) || ''}
                                            </div>

                                            <div className="ms-settings-switch">

                                                <button className="edit-button" >
                                                    <img
                                                        src={editIcon}
                                                        alt="editIcon"
                                                        onClick={() => { handleEditClick(proSettingsNameMapping[key]) }}
                                                    />
                                                </button>

                                                <Switch
                                                    className="siteSetting-switch"
                                                    checked={proSettings[key] || false}
                                                    onChange={(e) => handleChecker(key)}
                                                    disabled={editProSettingName}
                                                />
                                            </div>
                                        </div>
                                );
                            })}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <h3 className="placeholder" style={{ textAlign: "center", margin: "50px 0" }}>No Settings available</h3>
                        </React.Fragment>
                    )}


                </div>

                <div className="ms-settings-footer">
                    <div className="ms-settings-footer-sub">
                        <Button onClick={closeSettings} className="clear-btn" >
                            Cancel
                        </Button>
                        <Tooltip
                            placement="topLeft"
                            title={
                                editProSettingName
                                    ? "Save changes to Pro setting name first"
                                    : ProSettingsHasChanges
                                        ? "Save Pro settings update"
                                        : "Make changes to save"
                            }
                        >
                            <Button
                                className="redBtn"
                                onClick={submit}
                                loading={loading}
                                disabled={!ProSettingsHasChanges || editProSettingName}
                            >
                                Save
                            </Button>
                        </Tooltip>
                    </div>
                </div>
            </>
        </Modal>
    )
}

export default ProSettings  